import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer>
      <p>&copy; 2024 SivaSri Engineering Services</p>
    </footer>
  );
}

export default Footer;
